import { render } from "./PetProfileForm.vue?vue&type=template&id=0c2858c0&scoped=true"
import script from "./PetProfileForm.vue?vue&type=script&lang=js"
export * from "./PetProfileForm.vue?vue&type=script&lang=js"

import "./PetProfileForm.vue?vue&type=style&index=0&id=0c2858c0&lang=scss&scoped=true"

import exportComponent from "/tmp/build_195c5171/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2858c0"]])

export default __exports__